import API from '@/shared/plugins/Api/API'

class EnvironmentsV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  async list (appName) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/environment`
    })
    return response
  }

  async get (appName, key) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/environment/${encodeURIComponent(key)}`
    })
    return response
  }

  async create (appName, body) {
    const response = await this.request({
      method: 'post',
      url: `${this._appUrl(appName)}/environment`,
      data: body
    })
    return response
  }

  async update (appName, key, body) {
    const response = await this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/environment/${encodeURIComponent(key)}`,
      data: body
    })
    return response
  }

  async delete (appName, key) {
    await this.request({
      method: 'delete',
      url: `${this._appUrl(appName)}/environment/${encodeURIComponent(key)}`
    })
  }
}

export default EnvironmentsV3
